/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IgnoredReason } from './ignored-reason';
import { NycProfileStatus } from './nyc-profile-status';


export interface UserRegistrationDto { 
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    createdAt: string;
    /**
     * No Housing Connect credentials here: this endpoint returns a whole page of users at a time, and nothing renders them. The search still matches on the username -- server-side, against `RegistrationSearchEntry` in routes/mappers.ts, which keeps the username next to this DTO rather than inside it. Credentials come one user at a time from `revealHousingConnectCredentials`.
     */
    nycProfileStatus: NycProfileStatus;
    lastSyncStatus: string;
    loginStatus: string;
    ignore: boolean;
    ignoredReason: IgnoredReason;
    syncFailedCount: number;
    loginFailedCount: number;
    lastSyncError?: string;
    autoCreateStatus: UserRegistrationDto.AutoCreateStatusEnum;
    autoCreateFailureReason?: string;
}
export namespace UserRegistrationDto {
    export const AutoCreateStatusEnum = {
        pending: 'pending',
        in_progress: 'in-progress',
        failed: 'failed'
    } as const;
    export type AutoCreateStatusEnum = typeof AutoCreateStatusEnum[keyof typeof AutoCreateStatusEnum];
}


